import { FC } from "react";
import "./wave-hole.css";
import { WaveHoleBackgroundSvg, WaveHolePeriodSvg, WaveHoleTitleSvg } from "./wave-hole-svg";
import { TemplateBackgroundProps, TemplateLabelTitleProps, TemplateScheduleTableProps } from "./types";

const toRgb = (value: string) => `rgb(${value})`;

const toRgba = (value: string, alpha: number) => {
  const [red = 0, green = 0, blue = 0] = value.split(/\s+/).map((channel) => Number.parseFloat(channel));
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};

export const WaveHoleTemplateBackgroundDecoration: FC<TemplateBackgroundProps> = ({ theme }) => (
  <WaveHoleBackgroundSvg
    className="bgSvg"
    fillColor={toRgb(theme.light)}
    gridColor={toRgba(theme.back, 0.88)}
    shadowColor={toRgba(theme.base, 0.45)}
  />
);

export const WaveHoleTemplateLabelTitle: FC<TemplateLabelTitleProps> = ({
  periodStartLabel,
  periodEndLabel,
  theme,
}) => (
  <>
    <div className="titleHeading">
      <WaveHoleTitleSvg
        className="titleHeadingSvg"
        mainColor={toRgb(theme.base)}
        shadowColor={toRgb(theme.light)}
      />
    </div>
    <div className="titlePeriod">
      <WaveHolePeriodSvg
        className="titlePeriodBadge"
        fillColor={toRgb(theme.back)}
        iconColor={toRgb(theme.light)}
        outlineColor="#fff"
      />
      <div className="titlePeriodBody">
        <span className="titlePeriodDates">
          <span className="titlePeriodStart">{periodStartLabel}</span>
          <span className="titlePeriodEnd">{periodEndLabel}</span>
        </span>
      </div>
    </div>
  </>
);

export const WaveHoleTemplateScheduleTable: FC<
  {
    weekLabelDisplayType?: "jaShort" | "enShort" | "enLong";
  } & TemplateScheduleTableProps
> = ({ items, weekLabelDisplayType = "enShort", weekLabelSets }) => {
  const activeWeekLabels = weekLabelSets[weekLabelDisplayType];

  return (
    <div className="parts scheduleTable">
      {items.map((item, index) => (
        <div className={`item ${item.isOff ? "is-off" : ""}`.trim()} key={item.key}>
          <div className="itemHeader">
            <span className="day">{item.dayNumber}</span>
            <span className="week">{activeWeekLabels[index] ?? item.weekLabel}</span>
          </div>
          <div className="itemBody">
            {item.time && <p className="time">{item.time}</p>}
            <p className="content">{item.content}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
